@if (!accordion) {
	<app-loading-spinner></app-loading-spinner>
} @else {
	<div>
		<h2 class="mb-4">{{ accordion.label }}</h2>
	</div>
	<div class="accordion accordion-flush" id="multiLinkAccordion">
		@for (group of accordion.linkGroups; track $index) {
			<div class="accordion-item">
				<h2 class="accordion-header" [id]="'heading' + $index">
					<button
						class="accordion-button collapsed"
						type="button"
						data-bs-toggle="collapse"
						[attr.data-bs-target]="'#collapse' + $index"
						aria-expanded="true"
						[attr.aria-controls]="'collapse' + $index">
						<span>{{ group.label }}</span>
					</button>
				</h2>
				<div
					[id]="'collapse' + $index"
					class="accordion-collapse collapse"
					[attr.aria-controls]="'heading' + $index"
					data-bs-parent="#multiLinkAccordion">
					<div class="accordion-body link-list-wrapper pb-4">
						@for (link of group.links; track $index) {
							<ul class="link-list my-0 mx-3">
								<li class="d-flex align-items-center">
									<img [src]="link.iconUrl" class="p-1" style="height: 25px; width: 25px" alt="" />
									<a class="list-item p-0" [href]="link.address">
										<span>{{ link.label }}</span>
									</a>
								</li>
							</ul>
						}
					</div>
				</div>
			</div>
		}
	</div>
}
